import type { ComponentStyleConfig } from '@chakra-ui/react';

import inputStyleConfig from './input';

const SelectComponentStyle: ComponentStyleConfig = {
  defaultProps: {
    variant: 'default',
    size: 'sm',
  },
  variants: {
    categoryPicker: {
      field: {
        height: '62px',
        fontSize: '16px',
      },
    },
    languageSelector: {
      field: {
        height: '45px',
        borderColor: 'neutral100',
        borderWidth: 2,
        borderRadius: '6px',
        textTransform: 'uppercase',
        fontWeight: '700',
        fontSize: '.75rem',
        fontFamily: "'Assistant', Arial, sans-serif",
      },
    },
    default: {
      field: {
        // @ts-expect-error okay
        ...inputStyleConfig.baseStyle?.field,
        px: 3,
        borderRadius: 'md',
        cursor: 'pointer',
        flexShrink: 0,
      },
      icon: {
        color: 'neutral400',
      },
    },
  },
};

export default SelectComponentStyle;
